import React, { useEffect, useState } from 'react'
import { App } from './App'
import { Login } from './pages/Login'
import { DataContextProvider } from './context/DataContext'
import { Loader } from './components/common/spinner/Loader'
import { useAuth } from './context/AuthContext'
import { MobileUnderConstruction } from './MobileUnderConstruction'

const useWindowWide = (size: number) => {
   const [width, setWidth] = useState(window.innerWidth)

   useEffect(() => {
      const handleResize = () => setWidth(window.innerWidth)
      window.addEventListener('resize', handleResize)
      return () => window.removeEventListener('resize', handleResize)
   }, [])

   return width >= size
}

export const Root = () => {
   const { isLoggedIn, isLoadingAuth } = useAuth()
   const isWide = useWindowWide(1007)

   if (!isWide) {
      return <MobileUnderConstruction />
   }
   if (isLoadingAuth) {
      return <Loader />
   }

   return isLoggedIn ? (
      <DataContextProvider>
         <App />
      </DataContextProvider>
   ) : (
      <Login />
   )
}
